<div class="d-md-flex align-items-center bg-white p-3" *ngIf="!Filtri.pratiche">
  <a href="javascript:void(0)" class="d-flex align-items-center numeri">
    <label class="font-20"> {{titolo}} </label>
    &nbsp;
    <div class="d-flex  flex-column  align-items-center justify-content-center" style="padding-top: 3pt">
      <span class="d-flex justify-content-center font-14 font-weight-bold" > {{collectionSize}} </span>
      <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 0;" [ngStyle]="{'background-color': '#53c954'}" > &nbsp; </span>
    </div>
  </a>
  &nbsp;
  &nbsp;
  <a href="javascript:void(0)" class="d-flex align-items-center numeri" *ngIf="permission.isntOperativeRole('A')">
    <label class="font-20"> NUOVI </label>
    &nbsp;
<!--    <span class="badge font-20">{{nuovi}}</span>-->
    <div class="d-flex  flex-column  align-items-center justify-content-center" style="padding-top: 3pt">
      <span class="d-flex justify-content-center font-14 font-weight-bold" > {{nuovi}} </span>
      <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 0;" [ngStyle]="{'background-color': '#53c954'}" > &nbsp; </span>
    </div>
  </a>
  &nbsp;
  &nbsp;
  <a href="javascript:void(0)" class="d-flex align-items-center numeri" *ngIf="permission.isntOperativeRole('A')">
    <label class="font-20"> DA SPEDIRE </label>
    &nbsp;
    <div class="d-flex  flex-column  align-items-center justify-content-center" style="padding-top: 3pt">
      <span class="d-flex justify-content-center font-14 font-weight-bold" > {{lavorare}} </span>
      <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 0;" [ngStyle]="{'background-color': '#53c954'}" > &nbsp; </span>
    </div>
  </a>
  &nbsp;
  &nbsp;
  <a href="javascript:void(0)" class="d-flex align-items-center numeri" *ngIf="permission.isntOperativeRole('A')">
  <label class="font-20"> DA RITIRARE </label>
  &nbsp;
  <div class="d-flex  flex-column  align-items-center justify-content-center" style="padding-top: 3pt">
    <span class="d-flex justify-content-center font-14 font-weight-bold" > {{ritirare}} </span>
    <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 0;" [ngStyle]="{'background-color': '#53c954'}" > &nbsp; </span>
  </div>
</a>
  &nbsp;
  &nbsp;
  <a href="javascript:void(0)" class="d-flex align-items-center numeri" *ngIf="permission.isntOperativeRole('A')">
    <label class="font-20"> LDV </label>
    &nbsp;
    <div class="d-flex  flex-column  align-items-center justify-content-center" style="padding-top: 3pt">
      <span class="d-flex justify-content-center font-14 font-weight-bold" > {{ldv}} </span>
      <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 0;" [ngStyle]="{'background-color': '#53c954'}" > &nbsp; </span>
    </div>
  </a>
  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;   &nbsp;   &nbsp;   &nbsp;   &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;   &nbsp;   &nbsp;   &nbsp;   &nbsp;
  <label class="container" style=" width: auto; margin: auto; margin-left: 0;">
    <input type="checkbox"  [(ngModel)]="inlineclick" (ngModelChange)="inlineclickChange()">
    <span class="checkmark"></span>
    RIGA CLICCABILE
  </label>
<!--  <div class="col-1 " >-->
<!--    <div class="">-->
<!--      <label for="inlineclick" >riga cliccabile</label>-->
<!--      &nbsp;-->
<!--      <input id="inlineclick" [(ngModel)]="inlineclick" (ngModelChange)="inlineclickChange()" class="" type="checkbox">-->
<!--    </div>-->
<!--  </div>-->
  <div class="ml-auto mt-3 mt-md-0">
    <button *ngIf="statospedire && permission.isPermitted('spedisci')" (click)='spedisci()' type="button" class="btn btn-green">
      <i-feather name="send" class="feather " ></i-feather>
    <span class="ml-1 ">Spedisci</span>
  </button>
    <button *ngIf="statoRitirare && permission.isPermitted('spedisci')" (click)='spedisci()' type="button" class="btn btn-green">
      <i-feather name="send" class="feather " ></i-feather>
      <span class="ml-1 ">Ritira</span>
    </button>
   <!-- <button (click)='inviaSMSSelezionati()' *ngIf="permission.isPermitted('invio-sms') && permission.isntOperativeRole('A')" type="button" class="btn btn-green">
      <i-feather name="send" ></i-feather>
      <span class="ml-1">INVIA SMS</span>
    </button>-->
    <button *ngIf="statoDareCorriere && permission.isPermitted('pagamento-corriere')&& permission.isOperativeRoles(['A'])" (click)='paga_Coriere()' type="button" class="btn btn-green">
      <i class="fas fa-box "></i>
      <span class="ml-1">PAGA CORRIERE</span>
    </button>
    <button *ngIf="statoPagareLaera && permission.isOperativeRoles(['BM'])" (click)='paga_laera()' type="button" class="btn btn-green">
      <i class="fas fa-box "></i>
      <span class="ml-1">PAGA LAERA</span>
    </button>
    <button  (click)='stampamagnifest()' type="button" class="btn btn-green">
      <i-feather name="printer" class="feather "></i-feather>
      <span class="ml-1">STAMPA</span>
    </button>
    <button *ngIf="isAddEnabled && permission.isntOperativeRoles(['A','BM'])" (click)='Edit()' type="button" class="btn btn-ciano">
      <i class="fas fa-plus-circle "></i>
      <span class="ml-1">AGGIUNGI</span>
    </button>
    <button *ngIf="isAddEnabled && permission.isntOperativeRoles(['A','BM'])" (click)='Preventivo()' type="button" class="btn btn-ciano">
      <i class="fas fa-plus-circle "></i>
      <span class="ml-1">Preventivo</span>
    </button>
    <button  (click)='paga_Cliente()' *ngIf="permission.isPermitted('pagato') && permission.isntOperativeRoles(['A', 'BM'])" type="button" class="btn btn-ciano">
      <i class="far fa-credit-card"></i>
      <span class="ml-1">PAGATO</span>
    </button>
  </div>
</div>
<div *ngIf="hasFilter"  class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body p-t-0 p-b-0">
        <div class="row">
          <div class="col-lg-2" *ngIf="Filtri.pratiche && ShowFilter('codice')">
            <div class="form-group">
              <label for="codice" class="control-label col-form-label" >CODICE</label>
              <input id="codice"  required [(ngModel)]="Filtri.codice" (ngModelChange)="onFilterChange()" class="form-control" type="text">
            </div>
          </div>
          <div class="col-lg-2" *ngIf="!Filtri.pratiche && ShowFilter('inizio')">
            <div class="form-group">
              <label for="inizio" class="control-label col-form-label" >INIZIO</label>
              <input id="inizio"  required [(ngModel)]="Filtri.inizio" (ngModelChange)="onFilterChange()" class="form-control" type="date">
            </div>
          </div>
          <div class="col-lg-2" *ngIf="!Filtri.pratiche && ShowFilter('fine')">
            <div class="form-group">
              <label for="fine" class="control-label col-form-label" >FINE</label>
              <input id="fine"  required [(ngModel)]="Filtri.fine" (ngModelChange)="onFilterChange()" class="form-control" type="date">
            </div>
          </div>
          <div class="col-lg-2 " *ngIf="!Filtri.pratiche && ShowFilter('corriere')">
            <label for="categorie" required class="control-label col-form-label" > CORRIERE</label>
            <ng-multiselect-dropdown style="" class="font-14" [settings]="corrieredropdownSettings" [placeholder]="'Corriere'" id="categorie" [data]="corrieri"
            [(ngModel)]="corrierisel" (onSelect)="corriereSelezionato($event)" (onDeSelect)="corriereSelezionato($event)">
            </ng-multiselect-dropdown>
          </div>
          <div class="col-lg-2 " *ngIf="!Filtri.pratiche && ShowFilter('stato')">
            <label for="stato" required class="control-label col-form-label" > STATO</label>
            <ng-multiselect-dropdown class="font-14" [settings]="statidropdownSettings" [placeholder]="'Stato'" id="stato" [data]="stati"
            [(ngModel)]="statisel" (onSelect)="statoSelezionato($event)" (onDeSelect)="statoSelezionato($event)">
            </ng-multiselect-dropdown>
          </div>
          <div class="col-lg-2 " *ngIf="!Filtri.pratiche && ShowFilter('filtro')">
            <div class="form-group ">
               <label for="filtro" class="control-label col-form-label" >FILTRO</label>
              <input id="filtro" [(ngModel)]="Filtri.filtro" placeholder="Filtro" (ngModelChange)="onFilterChange()" class="form-control" type="text">
            </div>
          </div>
          <div class="col-lg-2 " *ngIf="permission.isPermitted('agenzia') && !Filtri.pratiche && ShowFilter('agenzia')" >
            <div class="form-group">
               <label for="agenzia" class="control-label col-form-label" >AGENZIA</label>
              <input id="agenzia"  [(ngModel)]="Filtri.agenzia" placeholder="Agenzia" (ngModelChange)="onFilterChange()" class="form-control" type="text">
            </div>
          </div>
          <div  class=" d-flex  col-lg-6" style="margin-top: 10px">
            <label *ngIf="!Filtri.pratiche && permission.isntOperativeRole('A') && ShowFilter('t12')" class="container" style="margin-left: 0; width: auto; margin-right: auto;">
              <input type="checkbox"  [(ngModel)]="Filtri.t12" (ngModelChange)="onFilterChange()">
              <span class="checkmark"></span>
              Link rapidi: &nbsp;  &nbsp;T12
            </label>
            <label *ngIf="!Filtri.pratiche && permission.isntOperativeRole('A') && ShowFilter('ritiro')" class="container" style="margin-left: auto; width: auto; ">
              <input type="checkbox"  [(ngModel)]="Filtri.ritiro" (ngModelChange)="onFilterChange()">
              <span class="checkmark"></span>
              RITIRO &nbsp;
            </label>
            <label *ngIf="!Filtri.pratiche && permission.isntOperativeRoles(['A', 'BM']) && ShowFilter('fattura')" class="container" style="margin-left: auto; width: auto; ">
              <input type="checkbox"  [(ngModel)]="Filtri.fattura" (ngModelChange)="onFilterChange()">
              <span class="checkmark"></span>
              FATTURA&nbsp;
            </label>
            <label *ngIf="!Filtri.pratiche && permission.isntOperativeRole('A')  && ShowFilter('triangolazione')" class="container" style="margin-left: auto; width: auto; ">
              <input type="checkbox" [(ngModel)]="Filtri.triangolazione" (ngModelChange)="onFilterChange()">
              <span class="checkmark"></span>
              TRIANGOLAZIONE&nbsp;
            </label>
            <label *ngIf="!Filtri.pratiche && !permission.isntOperativeRole('A')  && ShowFilter('internazionali')" class="container" style="margin-left: 0; width: auto; margin-right: auto;">
              <input type="checkbox"  [(ngModel)]="Filtri.internazionali" (ngModelChange)="onFilterChange()">
              <span class="checkmark"></span>
              {{ !permission.isntOperativeRole('A') ? 'Link rapidi: &nbsp;  &nbsp;' : ''}}
              INTERNAZIONALI&nbsp;
            </label>
            <label *ngIf="!Filtri.pratiche && permission.isntOperativeRole('A') && ShowFilter('internazionali')" class="container" style="margin-left: auto; width: auto; ">
              <input type="checkbox"  [(ngModel)]="Filtri.internazionali" (ngModelChange)="onFilterChange()">
              <span class="checkmark"></span>
              {{ !permission.isntOperativeRole('A') ? 'Link rapidi: &nbsp;  &nbsp;' : ''}}
              INTERNAZIONALI&nbsp;
            </label>
            <label *ngIf="!Filtri.pratiche && ShowFilter('nazionali')" class="container" style="margin-left: 0; width: auto; ">
              <input type="checkbox" [(ngModel)]="Filtri.nazionali" (ngModelChange)="onFilterChange()">
              <span class="checkmark"></span>
              NAZIONALI&nbsp;
            </label>
            <label *ngIf="Filtri.pratiche && permission.isntOperativeRole('A') && ShowFilter('pratiche') " class="container" style="margin-left: 0; width: auto;">
              <input type="checkbox" [(ngModel)]="Filtri.pratiche" (ngModelChange)="onFilterChange()">
              <span class="checkmark"></span>
              PRATICHE&nbsp;
            </label>
            <label *ngIf="!Filtri.pratiche && permission.isntOperativeRole('A') && ShowFilter('pratiche')" class="container" style="margin-left: auto; width: auto; ">
            <input type="checkbox" [(ngModel)]="Filtri.pratiche" (ngModelChange)="onFilterChange()">
            <span class="checkmark"></span>
            PRATICHE&nbsp;
          </label>
            <label *ngIf="Filtri.pratiche && permission.isntOperativeRole('A') && ShowFilter('chiuse')" class="container" style="margin-left: auto; width: auto; ">
              <input type="checkbox" [(ngModel)]="Filtri.chiuse" (ngModelChange)="onFilterChange()">
              <span class="checkmark"></span>
              CHIUSE&nbsp;
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  <div class="table-responsive">
  <table class="table  table-hover align-middle mb-0 table-fixed"  *ngIf="!Filtri.pratiche">
    <thead class="fi"   >
      <tr >
        <th scope="col" >
          <input type="checkbox" [(ngModel)]="isMasterSel" name="list_name" value="h1" (change)="checkUncheckAll()" />
        </th>
        <th style="text-align: center;" *ngIf="permission.isntOperativeRole('A')"><span class="font-20">Cod</span></th>
        <th style="text-align: center;"><span class="font-20">Data</span></th>
        <th style="text-align: center;" *ngIf="permission.isntOperativeRole('A')"><span class="font-20">Mittente</span></th>
        <th  style="text-align: center;"scope="col"><span class="font-20">Corriere</span></th>
        <th style="text-align: center;" scope="col"><span class="font-20">Lettera di vettura</span></th>
        <th style="text-align: center;" *ngIf="permission.isntOperativeRole('A')" scope="col"><span class="font-20">Destinatario</span></th>
        <th style="text-align: center;" *ngIf="permission.isntOperativeRole('A')" scope="col"><span class="font-20">Stato</span></th>
<!--        <th scope="col" *ngIf="permission.isPermitted('invio-sms')" ><span class="font-20">SMS</span></th>-->
        <th style="text-align: center;" scope="col" *ngIf="permission.isPermitted('agenzia')" ><span class="font-20">Agenzia</span></th>
        <th style="text-align: center;" scope="col" *ngIf="permission.isntOperativeRoles([ 'BM'])"><span class="font-20">Imp <br> {{ValoriColonne().Importo | number : "1.2-2"}} €</span></th>
        <th  style="text-align: center;" scope="col" *ngIf=" permission.isPermitted('gestione-info-costi')" ><span class="font-20">{{permission.isOperativeRoles(['A']) ? 'Corr': 'Laera'}} <br>{{ValoriColonne().Corriere | number : "1.2-2"}} €</span></th>
        <th style="text-align: center;" scope="col" *ngIf=" permission.isntOperativeRoles([ 'BM']) && permission.isPermitted('gestione-info-costi')" ><span class="font-20">Mar <br> {{ValoriColonne().Margine | number : "1.2-2"}} €</span></th>
        <th style="text-align: center;" scope="col" *ngIf="permission.isntOperativeRole('A')"><span class="font-20">Azioni</span></th>
      </tr>
    </thead>
    <tbody class="scrollable tablelist" >
      <tr *ngFor="let item of Spedizioni | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
        <td  class="align-middle"  >
          <input type="checkbox" [(ngModel)]="item.isSelected" name="list_name"
              (change)="isAllSelected()" />
        </td>
        <td *ngIf="permission.isntOperativeRole('A')" class="align-middle" (click)="Edit(item,true)">
          <div class="d-flex  flex-column  align-items-center justify-content-center">
            <span class="d-flex justify-content-center font-weight-bold " style="margin-top: 5pt;" > {{item.progressivo}} </span>
            <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 5pt;" [ngStyle]="{'background-color': item.files && item.files.length > 0 && item.files[0] ? '#ffc107' : 'transparent'}" > &nbsp; </span>
          </div>
        </td>
        <td class="align-middle" (click)="Edit(item,true)"  style="text-align: center;">
          <span class="font-14">{{item?.data_inizio_prevista | date: 'dd/MM/yyyy'}}</span>
        </td>
        <td *ngIf="permission.isntOperativeRole('A')" class="align-middle " (click)="Edit(item,true)">
            <span class="font-18">{{item?.mittente?.nome}}</span>
        </td>
        <td class="align-middle" (click)="Edit(item,true)"  style="text-align: center;">
          <span *ngIf="item.corriereObject" class="font-18">{{ item.corriereObject.nominativo }}</span>
        </td>
        <td class="align-middle" (click)="Edit(item,true)">
          <div class="d-flex  flex-column  align-items-center justify-content-center">
            <span class="d-flex justify-content-center font-14" style="margin-top: 5pt;" > {{item.ldv}} </span>
            <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 5pt;" [ngStyle]="{'background-color': item.costoContrassegno && item.costoContrassegno > 0  ? '#ffc107' : 'transparent'}" > &nbsp; </span>
          </div>
        </td>
        <td *ngIf="permission.isntOperativeRole('A')" class="align-middle " (click)="Edit(item,true)">
            <span class="font-18">{{item.destinatario?.nome}}</span>
        </td>
        <td *ngIf="permission.isntOperativeRole('A')" class="align-middle" (click)="sendsms(item)">
          <div class="d-flex  flex-column  align-items-center justify-content-center">
            <span *ngIf="item.smsD && item.smsM" class="badge badge-success text-dark rounded-pill font-16 mr-1">{{ item.stato }}</span>
            <span *ngIf="!item.smsD || !item.smsM" class="d-flex justify-content-center font-14" style="margin-top: 5pt;" > {{ item.stato }} </span>
<!--            <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 5pt;" [ngStyle]="{'background-color': item.smsD && item.smsM  ? '#53c954' : 'transparent'}" > &nbsp; </span>-->
          </div>
<!--            <span class="font-18">{{ item.stato }}</span>-->
        </td>
<!--        <td class="align-middle" *ngIf="permission.isPermitted('invio-sms')">-->
<!--          <span *ngIf="item.smsD && item.smsM" class="badge badge-success text-dark rounded-pill font-16 mr-1">Inviato</span>-->
<!--          <a *ngIf="!item.smsD || !item.smsM" href="javascript:void(0)" ngbTooltip="Invia SMS" class="link font-16 text-info font-medium mr-2"-->
<!--             (click)="sendsms(item)">-->
<!--            <i-feather name="send" style="color: #53c954" class="feather-sm"></i-feather>-->
<!--          </a>-->
<!--        </td>-->
        <td *ngIf="permission.isPermitted('agenzia')" class="align-middle" (click)="Edit(item,true)">
          <div class="d-flex  flex-column  align-items-center justify-content-center">
            <span class="d-flex justify-content-center font-14" style="margin-top: 5pt;" > {{item.manager?.fullName}} </span>
            <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 5pt;" [ngStyle]="{'background-color': item?.manager?.id != AuthenticationService?.currentUserValue?.id  ? '#ffc107' : 'transparent'}" > &nbsp; </span>
          </div>
        </td>
        <td  class="align-middle" *ngIf="permission.isntOperativeRoles([ 'BM'])" (click)="Edit(item,true)">
          <div class="d-flex  flex-column  align-items-center justify-content-center">
            <span class="d-flex justify-content-center font-14" style="margin-top: 5pt;" > {{ ValoriColonne(item).Importo  | number : "1.2-2"}}€ </span>
            <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 5pt;" [ngStyle]="{'background-color': (permission.isOperativeRoles(['A']) ? item.pagatoLaera : item?.clienteHaPagato)  ? '#53c954' : '#fc2c2c'}" > &nbsp; </span>
          </div>
        </td>
        <td *ngIf=" permission.isPermitted('gestione-info-costi') || permission.isOperativeRoles(['BM']) " class="align-middle" (click)="Edit(item,true)">
          <div class="d-flex  flex-column  align-items-center justify-content-center">
            <span class="d-flex justify-content-center font-14" style="margin-top: 5pt;" > {{ ValoriColonne(item).Corriere | number : "1.2-2"}}€ </span>
            <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 5pt;" [ngStyle]="{'background-color': (permission.isOperativeRoles(['A']) ? item?.pagatoCorriere : item?.pagatoLaera)   ? '#53c954' : '#fc2c2c'}" > &nbsp; </span>
          </div>

        </td>
        <td *ngIf="permission.isPermitted('gestione-info-costi')  && permission.isntOperativeRoles(['BM'])" class="align-middle" (click)="Edit(item,true)">
          <div class="d-flex  flex-column  align-items-center justify-content-center">
            <span class="d-flex justify-content-center font-14" style="margin-top: 5pt;" > {{ ValoriColonne(item).Margine  | number : "1.2-2"}}€ </span>
            <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 5pt;" [ngStyle]="{'background-color': ( permission.isOperativeRoles(['A']) ? item?.pagatoCorriere && item.pagatoLaera : item?.pagatoLaera && item.clienteHaPagato) ? '#53c954' : '#fc2c2c'}" > &nbsp; </span>
          </div>
        </td>
        <td class="align-middle" *ngIf="permission.isntOperativeRole('A')">
          <a href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2"
            (click)="Edit(item,false)">
            <i-feather name="edit-3" class="feather-sm"></i-feather>
          </a>
          <a href="javascript:void(0)" ngbTooltip="Modifica in nuova scheda" class="link font-16 text-orange font-medium mr-2"
             (click)="EditNewTAb(item)">
            <i-feather name="edit-3" class="feather-sm"></i-feather>
          </a>
          <a href="javascript:void(0)" *ngIf="isAdmin " ngbTooltip="Elimina" class="link font-16 text-danger font-weight-bold"
            (click)='delete(item)'>
            <i-feather name="trash-2" class="feather-sm"></i-feather>
          </a>
          <a href="javascript:void(0)" *ngIf="item?.ldv?.length>0"  ngbTooltip="Vai al Tracking" class="link font-16 text-info font-weight-bold"
             (click)='Tracking(item)'>
            <i class="fas fa-box-open"></i>
          </a>
          <a href="javascript:void(0)" *ngIf="!(item?.email) && item?.destinatario?.email && this.permission.isPermitted('invio-sms')"  ngbTooltip="invia Email Destinatario" class="link font-16 text-info font-weight-bold"
             (click)='SendEmail(item)'>
            <i  class="fas fa-at fa-lg"></i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
    <table class="table  table-hover align-middle mb-0 table-fixed"  *ngIf="Filtri.pratiche">
      <thead class="fi"   >
      <tr >
        <th scope="col" >
          <input type="checkbox" [(ngModel)]="isMasterSel" name="list_name" value="h1"
                 (change)="checkUncheckAll()" />
        </th>
        <th scope="col"><span class="font-20">Lettera di vettura</span></th>
        <th><span class="font-20">Data</span></th>
        <th scope="col"><span class="font-20">Corriere</span></th>
        <th><span class="font-20">Cod</span></th>
        <th><span class="font-20">Codice Pratica</span></th>
        <th scope="col"><span class="font-20">Note Pratica</span></th>
        <th scope="col"><span class="font-20">Azioni</span></th>
      </tr>
      </thead>
      <tbody class="scrollable tablelist" >
      <tr *ngFor="let item of Spedizioni | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
        <td  class="align-middle"  >
          <input type="checkbox" [(ngModel)]="item.isSelected" name="list_name"
                 (change)="isAllSelected()" />
        </td>
        <td class="align-middle" (click)="Edit(item,true)">
          <div class="d-flex  flex-column  align-items-center justify-content-center">
            <span class="d-flex justify-content-center font-14" style="margin-top: 5pt;" > {{item.ldv}} </span>
            <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 5pt;" [ngStyle]="{'background-color': item.costoContrassegno && item.costoContrassegno > 0  ? '#ffc107' : 'transparent'}" > &nbsp; </span>
          </div>
        </td>

        <td class="align-middle" (click)="Edit(item,true)">
          <span class="font-14">{{item?.data_inizio_prevista | date: 'dd/MM/yyyy'}}</span>
        </td>
        <td class="align-middle" (click)="Edit(item,true)">
          <span *ngIf="item.corriereObject" class="font-18">{{ item.corriereObject.nominativo }}</span>
        </td>
        <td class="align-middle" (click)="Edit(item,true)">
          <div class="d-flex  flex-column  align-items-center justify-content-center">
            <span class="d-flex justify-content-center" style="margin-top: 5pt;" > {{item.progressivo}} </span>
            <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 5pt;" [ngStyle]="{'background-color': item.files && item.files.length > 0 && item.files[0] ? '#ffc107' : 'transparent'}" > &nbsp; </span>
          </div>
        </td>
        <td class="align-middle " (click)="Edit(item,true)">
          <span class="font-18">{{item.codicePratica}}</span>
        </td>
        <td class="align-middle" (click)="Edit(item,true)">
          <span class="font-18">{{ item.notePratica }}</span>
        </td>
        <td class="align-middle">
          <a href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2"
             (click)="Edit(item,false)">
            <i-feather name="edit-3" class="feather-sm"></i-feather>
          </a>
          <a href="javascript:void(0)" ngbTooltip="Modifica in nuova scheda" class="link font-16 text-orange font-medium mr-2"
             (click)="EditNewTAb(item)">
            <i-feather name="edit-3" class="feather-sm"></i-feather>
          </a>
          <a href="javascript:void(0)" *ngIf="isAdmin" ngbTooltip="Elimina" class="link font-16 text-danger font-weight-bold"
             (click)='delete(item)'>
            <i-feather name="trash-2" class="feather-sm"></i-feather>
          </a>
          <a href="javascript:void(0)" *ngIf="item?.ldv?.length>0"  ngbTooltip="Vai al Tracking" class="link font-16 text-info font-weight-bold"
             (click)='Tracking(item)'>
            <i class="fas fa-box-open"></i>
          </a>
        </td>
      </tr>
      </tbody>
    </table>
</div>


<div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
  <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
    [collectionSize]="collectionSize" [pageSize]="pageSize">
  </ngb-pagination>
</div>
